/**
 * «شهرم را از موقعیتم پیدا کن» — **بالای** فیلدهای کشور/شهر.
 *
 * زیرشان بود و آن‌جا کارِ چندانی نمی‌کرد: کسی که تا آن پایین رسیده، از
 * تایپ کردن فارغ شده و دیگر میان‌بری لازم ندارد. راهِ کوتاه باید قبل از
 * راهِ دراز دیده شود، وگرنه راهِ کوتاه نیست.
 *
 * قرینه‌ی apps/mobile/src/features/profile/FindMyCityRow.tsx. منطقش مشترک
 * است (`core/lib/findMyCity`)؛ آنچه این‌جا می‌ماند فقط گرفتنِ مختصات با
 * `navigator.geolocation` و شکلِ ردیف است.
 *
 * ⚠ اجازه **تنبل** گرفته می‌شود: تا کسی خودش این دکمه را نزده هیچ پنجره‌ای
 * باز نمی‌شود. پرسیدنِ موقعیت به‌محضِ باز شدنِ فرمِ ثبت‌نام دقیقاً همان چیزی
 * است که آدم‌ها رد می‌کنند — و مرورگر بعد از یک «نه» دیگر حتی نمی‌پرسد.
 * وقتی خودش دکمه را زده، می‌داند چرا پرسیده می‌شود.
 */
import React, { useState } from 'react';
import { findMyCity } from '@/core/lib/findMyCity';
import { t } from '@/core/lib/i18n';
import { useMyLocation } from '@/features/discover/useMyLocation';
import type { WhereYouLiveState } from '@/features/profile/WhereYouLive';

export function FindMyCityRow({ state }: { state: WhereYouLiveState }) {
  const { ensure } = useMyLocation();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const run = async () => {
    setBusy(true);
    setMsg(null);
    try {
      const r = await findMyCity(ensure);
      if (r.ok) {
        state.setCountry(r.country);
        state.setCity(r.city.name, r.city.id);
        return;
      }
      setMsg(t(r.reason === 'noCity' ? 'locationNoCity' : 'locationDeniedCity'));
    } finally {
      setBusy(false);
    }
  };

  return (
    /* دکمه اول است و توضیح کنارش، نه برعکس: چیزی که باید دیده شود دکمه
       است، و متن فقط می‌گوید چرا. قابِ دکمه هم می‌ماند (ghost نه): چیزی
       که تا ماوس رویش نرود دکمه به نظر نرسد، دکمه نیست. */
    <div className="find-my-city">
      <button type="button" className="btn" disabled={busy} onClick={() => void run()}>
        {busy ? t('locating') : t('useMyLocation')}
      </button>
      <p className="dim">{t('locationOffer')}</p>
      {msg ? <p className="error">{msg}</p> : null}
    </div>
  );
}
